import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectApplicationAssessmentSummary } from 'src/screens/shared/application/assessment/details/summary/ProjectApplicationAssessmentSummary'

export const PfPgvAssessmentDetailsSummaryPage = (): ReactElement => {
  const { projectId, assessmentId } = useParams()
  const pf_pgv_project_id = parseInt(projectId as string)
  const pf_pgv_assessment_id = parseInt(assessmentId as string)

  return (
    <ProjectApplicationAssessmentSummary
      baseUrl="/pf-pgv"
      projectId={pf_pgv_project_id}
      assessmentId={pf_pgv_assessment_id}
    />
  )
}
